module.exports = __webpack_public_path__ + "d4e2909b4c41705dde9f18e5e763e7cb.png";